export default {
  common: {
    email: 'ای میل',
    phone: 'فون',
    phoneNumber: 'فون نمبر',
    countrySelect: 'ملک کا انتخاب کریں۔',
    countryUnmodifiedNote: 'رجسٹریشن کے بعد ملک میں ترمیم نہیں کی جا سکتی',
    next: 'اگلا',
    back: 'پیچھے',
    attention: 'توجہ',
    cancel: 'منسوخ کریں۔',
    confirm: 'تصدیق کریں۔',
    modify: 'ترمیم کریں۔',
    ignore: 'نظر انداز کرنا',
    firstName: 'پہلا نام',
    middleName: 'درمیانی نام',
    lastName: 'آخری نام',
    gender: 'جنس',
    male: 'مرد',
    female: 'خاتون',
    birthday: 'سالگرہ',
    graphicCode: 'گرافک کوڈ',
    emailCode: 'ای میل تصدیقی کوڈ',
    smsCode: 'ایس ایم ایس کوڈ',
    smsVerificationCode: 'ایس ایم ایس توثیقی کوڈ',
    bind: 'باندھنا',
    send: 'بھیجیں۔',
    resend: 'دوبارہ بھیجیں۔',
    address: 'پتہ',
    done: 'ہو گیا',
    systemMessage: 'سسٹم کا پیغام',
    setting: 'ترتیب',
    submit: 'جمع کروائیں۔',
    language: 'زبان',
    edit: 'ترمیم کریں۔',
    delete: 'حذف کریں۔'
  },
  account: {
    account: 'اکاؤنٹ',
    nickname: 'عرفی نام',
    id: 'ID',
    basicInfo: 'بنیادی سطح',
    placeholder: 'براہ کرم درج کریں۔',
    completed: 'مکمل',
    semiInfo: 'نیم تصدیق شدہ',
    fullyInfo: 'مکمل طور پر تصدیق شدہ',
    basicTab: 'بنیادی',
    advancedTab: 'ایڈوانسڈ',
    linkedAccount: 'منسلک واپسی اکاؤنٹ',
    accountSecurity: 'MetWallet اکاؤنٹ اور حفاظت',
    logout: 'لاگ آؤٹ کریں۔',
    semiToast: 'براہ کرم بنیادی سطح کی توثیق مکمل کریں۔',
    fullyToast: 'براہ کرم بنیادی سطح کو مکمل کریں \n اور نیم تصدیق شدہ',
    quickLoginTitle: 'فوری لاگ ان',
    cancelQuickLogin: 'کیا آپ کو فوری لاگ ان کو غیر فعال کرنے کا یقین ہے؟'
  },
  accountSecurity: {
    title: 'اکاؤنٹ اور حفاظت',
    payPwd: 'ادائیگی کا پاس ورڈ',
    loginPwd: 'لاگ ان پاس ورڈ',
    changeEmail: 'ای میل تبدیل کریں۔',
    changePhone: 'فون نمبر تبدیل کریں۔',
    changePayPwd: 'ادائیگی کا پاس ورڈ تبدیل کریں۔',
    changeLoginPwd: 'لاگ ان پاس ورڈ تبدیل کریں۔',
    bindEmail: 'ای میل باندھیں۔',
    bindEmailNote: 'اسے پابند کرنے کے لیے ای میل کی توثیق پاس کریں۔',
    bindEmailPlaceholder: 'وہ ای میل درج کریں جسے آپ پابند کرنا چاہتے ہیں۔',
    smsBindNote: 'اسے پابند کرنے کے لیے ایس ایم ایس کی تصدیق پاس کریں۔',
    bindPhone: 'فون نمبر باندھیں۔',
    smsAuthentication: 'ایس ایم ایس کی توثیق',
    emailAuthentication: 'ای میل کی توثیق',
    phoneVerificationNote: 'پہلے موجودہ فون نمبر کی تصدیق پاس کریں۔',
    bindPhonePlaceholder: 'وہ فون نمبر درج کریں جسے آپ پابند کرنا چاہتے ہیں۔',
    verificationWrongToast: 'براہ کرم اپنا تصدیقی کوڈ چیک کریں۔',
    phoneNumberEmptyToast: 'براہ کرم فون نمبر پُر کریں۔',
    verificationCodeEmptyToast: 'براہ کرم کوڈ پُر کریں۔',
    wrongCodeToast: 'غلط کوڈ',
    changeNote: 'براہ کرم اسے تبدیل کرنے کے لیے تصدیق پاس کریں۔',
    newEmailVerification: 'نئی ای میل کی توثیق',
    newEmailPlaceholder: 'اپنا نیا ای میل درج کریں۔',
    change: 'تبدیلی',
    emailLowercaseToast: 'ای میل چھوٹے حروف میں ہونا چاہیے۔',
    newEmailEmptyToast: 'براہ کرم نیا ای میل پُر کریں۔',
    changeSuccessToast: 'کامیابی سے تبدیل کریں۔',
    phonePlaceholder: 'فون داخل کریں۔',
    currentEmail: 'موجودہ ای میل',
    passCurrentEmailVerificationFirst: 'پہلے موجودہ ای میل کی تصدیق پاس کریں۔',
    currentEmailVerification: 'موجودہ ای میل کی توثیق',
    smsVerification: 'ایس ایم ایس کی تصدیق',
    currentPhoneNumber: 'موجودہ فون نمبر',
    currentPhoneVerification: 'موجودہ فون کی تصدیق',
    currentEmailAddress: 'موجودہ ای میل ایڈریس',
    phoneVerification: 'فون کی تصدیق',
    enterVerificationCode: 'تصدیقی کوڈ درج کریں۔',
    newPhoneNumber: 'نیا فون نمبر',
    newEmail: 'نئی ای میل'
  },
  withdrawAccount: {
    selectAccountType: 'اکاؤنٹ کی قسم منتخب کریں۔',
    noBasicLevelVerificationDialog: 'براہ کرم کیش آؤٹ طریقہ کو پابند کرنے سے پہلے بنیادی سطح کی تصدیق مکمل کریں۔',
    bindNote: 'براہ کرم اکاؤنٹ کی درست معلومات پُر کریں، ورنہ آپ کی واپسی متاثر ہوگی۔',
    bindBankAccount: 'بنک اکاؤنٹ باندھیں۔',
    bindMobileMoneyAccount: 'موبائل منی اکاؤنٹ باندھیں۔',
    fieldEmptyToast: '{0} درکار ہے۔',
    fieldLengthToast: '{0} میں کم از کم {1} حروف ہونا چاہیے۔',
    bindBankRepeatToast: 'ایک ہی بینک اکاؤنٹ کو بار بار پابند نہ کریں!',
    accountName: 'اکاؤنٹ کا نام',
    ifscCode: 'IFSC کوڈ',
    accountEmptyToast: 'اکاؤنٹ درکار ہے۔',
    accountNameEmptyToast: 'اکاؤنٹ کا نام درکار ہے۔',
    phoneEmptyToast: 'فون درکار ہے۔',
    emailEmptyToast: 'ای میل درکار ہے۔',
    ifscCodeEmptyToast: 'IFSC کوڈ درکار ہے۔',
    ifscCodeLengthToast: 'IFSC کوڈ 11 ہندسوں کا ہونا چاہیے۔',
    bindIMPSRepeatToast: 'ایک ہی IMPS اکاؤنٹ کو بار بار پابند نہ کریں!',
    bindNote2:
      'براہ کرم اپنا درست TRC-20 پتہ پُر کریں۔ غلط پتہ کی وجہ سے ادائیگی ضائع ہو جائے گی، جس کی ہم کوئی ذمہ داری نہیں لیتے۔',
    usdtAddress: 'USDT پتہ (TRC-20):',
    minimumLimit: 'فی لین دین کے لیے کم از کم واپسی: $10',
    usdtFee: 'فیس: اصل فیوں کے تابع',
    registerGcash: 'اگر آپ کے پاس Gcash اکاؤنٹ نہیں ہے، تو براہ کرم رجسٹر کرنے کے لیے یہاں کلک کریں۔',
    registerEpay: 'اگر آپ کے پاس Epay اکاؤنٹ نہیں ہے، تو براہ کرم رجسٹر کرنے کے لیے یہاں کلک کریں۔',
    bindThirdPartyTitle: '{0} اکاؤنٹ باندھیں۔',
    wrongAccountToast: 'غلط اکاؤنٹ',
    accountFormatToast: 'اکاؤنٹ کا فارمیٹ غلط ہے۔',
    bindThirdPartyFailedToast: '{0} بائنڈنگ ناکام ہو گئی۔',
    queryFailedToast: 'استفسار ناکام ہو گیا۔',
    editFailedToast: 'ناکام ترمیم۔',
    add: 'شامل کریں۔',
    confirmEditDialog: 'کیا آپ واقعی اکاؤنٹ {0} میں ترمیم کرنا چاہتے ہیں؟',
    payPwdRequireDialog: 'اکاؤنٹ شامل کرنے سے پہلے براہ کرم 6 ہندسوں کا ادائیگی کا پاس ورڈ سیٹ کریں۔',
    unbindFailedToast: 'ان بائنڈنگ ناکام ہو گئی۔',
    cashOutSuccessNote: 'متوقع آمد کا وقت: 7 کام کے دنوں کے اندر',
    requestSubmitted: 'رقم نکلوانے کی درخواست جمع کرا دی گئی',
    amountLimitToast1: 'کیش آؤٹ کی رقم ≥$40.00 ہونی چاہیے۔',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'کیش آؤٹ کی رقم ≥${0}.00 ہونی چاہیے۔',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'تجاویز: نکالنے سے پہلے رقم کو ${0} تک جمع کرنے سے آپ کی پروسیسنگ فیس مؤثر طریقے سے بچ جائے گی۔',
    amountNotEnoughToast: 'کیش آؤٹ کی رقم کافی نہیں ہے۔',
    exceedingLimitToast1: 'آج کیش آؤٹ کی رقم بالائی حد تک پہنچ گئی ہے۔',
    exceedingLimitToast2:
      'آج کیش آؤٹ کی رقم بالائی حد تک پہنچ گئی ہے۔ کیا آپ کو حد بڑھانے کے لیے جدید سرٹیفیکیشن مکمل کرنے کی ضرورت ہے؟',
    restrictedCountriesPayPalAccountToast:
      'ممنوع ممالک پے پال اکاؤنٹ استعمال نہ کریں، جس کی وجہ سے آپ کا Arripay بلاک ہو جائے گا۔',
    withdrawMinimumToast: 'فی لین دین کے لیے کم از کم واپسی: $40',
    bankNotAvailableToast: 'یہ بینک اب دستیاب نہیں ہے، براہ کرم دوسرے بینکوں کو پابند کریں۔',
    usdtAccountInvalidToast: 'یہ USDT اکاؤنٹ نکالنے کے قابل نہیں ہے، براہ کرم نکالنے کے لیے نیا اکاؤنٹ استعمال کریں۔',
    noPayPwdToast: 'براہ کرم کیش آؤٹ کرنے سے پہلے 6 ہندسوں کا پیمنٹ پاس ورڈ سیٹ کریں۔',
    editBankAccount: 'بینک اکاؤنٹ میں ترمیم کریں۔',
    accountPlaceholder: 'اپنا اکاؤنٹ درج کریں۔',
    trc20Placeholder: 'TRC-20 ایڈریس درج کریں۔',
    accountRepeatToast: 'موجودہ جیسا ہی۔',
    unbindBankCardConfirmDialog: 'کیا آپ یقینی طور پر بینک کارڈ {0} کی پابندی ختم کرنا چاہتے ہیں؟',
    unbindMobileMoneyAccountConfirmDialog: 'کیا آپ یقینی طور پر موبائل منی اکاؤنٹ {0} کی پابندی ختم کرنا چاہتے ہیں؟',
    unbindAccountConfirmDialog: 'کیا آپ یقینی طور پر اکاؤنٹ {0} کی پابندی ختم کرنا چاہتے ہیں؟',
    availableBalance: 'دستیاب بیلنس {0}',
    estimatedFee: 'تخمینی فیس',
    submitFailToast: 'جمع کرانے میں ناکام',
    disabledMethodToast: 'یہ چینل عارضی طور پر دستیاب نہیں ہے۔',
    channelUnavailableTitle: 'چینل دستیاب نہیں',
    channelUnavailableNote: 'یہ رقم نکالنے کا چینل عارضی طور پر دستیاب نہیں ہے۔ براہ کرم کوئی اور طریقہ آزمائیں۔',
    channelUnavailableOk: 'ٹھیک ہے',
    bankTransferUnavailableTitle: 'بینک ٹرانسفر دستیاب نہیں',
    bankTransferUnavailableNote:
      'آپ کے اکاؤنٹ کے لیے بینک ٹرانسفر اس وقت دستیاب نہیں ہے۔ براہ کرم رقم نکالنے کے لیے Epay استعمال کریں۔',
    channelMaintenanceTitle: 'چینل زیر تعمیر',
    channelMaintenanceNote: 'یہ رقم نکالنے کا چینل زیر تعمیر ہے۔ براہ کرم کوئی اور طریقہ آزمائیں۔',
    bankInfoUpdateTitle: 'اپنے بینک کی معلومات اپ ڈیٹ کریں',
    bankInfoUpdateNote:
      'بینک کی پالیسی میں تبدیلی کی وجہ سے، براہ کرم جاری رکھنے کے لیے اپنے بینک کی تفصیلات اپ ڈیٹ کریں۔',
    bindEpay: 'Epay بائنڈ کریں',
    useEpay: 'Epay استعمال کریں',
    iMPSMaxLimitToast: 'اس چینل کے ذریعے ایک لین دین کے لیے زیادہ سے زیادہ رقم نکلوانے کی رقم $260 ہے۔',
    linkedAccount: 'اکاؤنٹ شامل کیا گیا۔',
    otherAccounts: 'دوسرے اکاؤنٹس شامل کیے جاسکتے ہیں۔',
    withdrawTo: 'میں منتقل کریں۔',
    withdrawAmount: 'منتقلی کی رقم',
    withdrawable: 'قابل واپسی',
    documentIdToast: 'شناختی نمبر میں صرف نمبر ہوسکتے ہیں۔',
    noAvailableMethodNote: 'کوئی دستیاب نکالنے کا طریقہ نہیں ہے',
    recommended: 'تجویز کردہ'
  },
  paymentCode: {
    changePayPwd: 'ادائیگی کا پاس ورڈ تبدیل کریں۔',
    setPayPwd: 'ادائیگی کا پاس ورڈ سیٹ کریں۔',
    setPayPwdNote: 'براہ کرم 6 ہندسوں کا ادائیگی کا پاس ورڈ سیٹ کریں۔',
    reenterPayPwdNote: 'دوبارہ داخل کریں۔',
    verificationNote: 'براہ کرم اسے سیٹ کرنے کے لیے تصدیق پاس کریں۔',
    emailVerification: 'ای میل کی توثیق',
    inconsistentPasswordToast: 'متضاد پاس ورڈ',
    payPwdNote: 'براہ کرم ادائیگی کا پاس ورڈ درج کریں۔',
    payPwdFormatToast: 'ادائیگی کا پاس ورڈ 6 ہندسوں کا نمبر ہے۔',
    payPwdWrongToast: 'غلط ادائیگی کا پاس ورڈ',
    payPwdVerificationFailToast: 'ادائیگی کے پاس ورڈ کی توثیق ناکام ہوگئی!',
    successToast: 'کامیابی سے سیٹ \n'
  },
  authorize: {
    requirement:
      'آپ کے لیے متعلقہ خدمات فراہم کرنے کے لیے {0} کو آپ کے MetWallet کی درج ذیل معلومات حاصل کرنے کی ضرورت ہے{1}۔ عرفیت، اوتار، جنس وغیرہ۔',
    authorize: 'اختیار دینا',
    switchAccount: 'اکاؤنٹ سوئچ کریں۔',
    goToMetWallet: 'MetWallet پر جائیں۔',
    notMatchTips: 'آپریشن ناکام ہو گیا۔ آپ صرف اپنے پابند MetWallet اکاؤنٹ کے ساتھ فوری لاگ ان کو فعال کر سکتے ہیں۔'
  },
  basicLevel: {
    namePlaceholder: 'کوئی علامت، نمبر نہیں۔',
    verification: 'تصدیق',
    whatsAvailable: 'کیا دستیاب ہے۔',
    cashOut: 'کیش آؤٹ',
    withdrawLimit: '$50 فی دن',
    basicLevelNote: 'براہ کرم اپنی اصلی ذاتی معلومات درج کریں۔ غلط معلومات کی وجہ سے رقم نکاسی ناکام ہو سکتی ہے۔',
    fieldEmptyToast: 'براہ کرم تمام مطلوبہ فیلڈز کو پُر کریں۔',
    successToast: 'محفوظ کیا گیا \n کامیابی سے',
    failToast: 'محفوظ کرنا ناکام ہو گیا۔',
    confirmDialog: 'اپنی اصلی ذاتی معلومات درج کرنا یقینی بنائیں۔ غلط معلومات کی وجہ سے رقم نکاسی ناکام ہو سکتی ہے۔',
    birthdayFormatToast: 'غلط برتھ ڈے فیلڈ فارمیٹ',
    verificationCodeError: 'توثیقی کوڈ کی خرابی۔',
    verificationCodeEmpty: 'توثیقی کوڈ خالی ہے۔',
    noEmailCodeToast: 'براہ کرم ای میل تصدیقی کوڈ حاصل کریں۔',
    checkDialogTitle: 'اپنی معلومات چیک کریں',
    checkDialogContent:
      'کامیابی سے رقم نکالنے کے لیے، براہ کرم اپنی معلومات چیک کریں۔ غلط معلومات کی وجہ سے رقم نکاسی ناکام ہو سکتی ہے۔',
    check: 'چیک کریں'
  },
  semiVerified: {
    uploadPhotoId: 'فوٹو آئی ڈی اپ لوڈ کریں۔',
    photoId: 'فوٹو آئی ڈی',
    resubmit: 'دوبارہ جمع کرائیں',
    limit: '$5,000 فی دن',
    uploading: 'اپ لوڈ ہو رہا ہے...',
    notUploadProofToast: 'براہ کرم شناختی کارڈ کا ثبوت اپ لوڈ کریں۔'
  },
  fullyVerified: {
    frontOfId: 'شناختی کارڈ سامنے',
    backOfId: 'شناختی کارڈ پیچھے',
    uploadIdFront: 'شناختی کارڈ سامنے اپ لوڈ کریں',
    uploadIdBack: 'شناختی کارڈ پیچھے اپ لوڈ کریں',
    withdrawDailyHint: 'رقم نکالنے کے لیے معلومات بھریں > {0} یومیہ۔',
    notUploadIdToast: 'براہ کرم شناختی کارڈ کے دونوں رخ اپ لوڈ کریں',
    proofTitle: 'رہائشی دستاویز کا ثبوت',
    acceptableProof: 'رہائش کا ایک قابل قبول ثبوت یہ ہے:',
    acceptableProof1: 'بینک اکاؤنٹ کا بیان۔',
    acceptableProof2: 'یوٹیلیٹی بل (بجلی، پانی، انٹرنیٹ، وغیرہ)۔',
    acceptableProof3: 'حکومت کی طرف سے جاری کردہ دستاویز (ٹیکس اسٹیٹمنٹ، رہائش کا سرٹیفکیٹ وغیرہ)۔',
    unacceptableProof:
      'ہم آپ کی جمع کرائی گئی شناختی دستاویز پر موجود پتے کو رہائش کے درست ثبوت کے طور پر قبول نہیں کر سکتے۔',
    limit: '$10,000 فی دن',
    notUploadToast: 'براہ کرم رہائشی دستاویز کا ثبوت اپ لوڈ کریں۔',
    incorrectFormatToast: 'براہ کرم jpg/png/jpeg تصویر اپ لوڈ کریں۔'
  },
  loginAndRegister: {
    pwd: 'پاس ورڈ',
    lastLogin: 'آخری لاگ ان',
    moreOptions: 'مزید اختیارات',
    agreeCheckboxContent: '{0} اور {1} سے متفق ہوں',
    userAgreement: 'صارف کا معاہدہ',
    privacyPolicy: 'رازداری کی پالیسی',
    notAgreeToast: 'صارف کے معاہدے اور رازداری کی پالیسی سے اتفاق کریں۔',
    forgotPassword: 'پاس ورڈ بھول گئے۔',
    linkedMail: 'لنکڈ میل',
    verificationCode: 'تصدیقی کوڈ',
    newPwd: 'نیا پاس ورڈ',
    repeatPwd: 'پاس ورڈ کو دہرائیں۔',
    confirmPwd: 'پاس ورڈ کی تصدیق کریں۔',
    noLinkedEmailToast: 'آپ کے اکاؤنٹ کے ساتھ کوئی منسلک ای میل نہیں ہے۔',
    unregisteredToast: 'یہ نمبر رجسٹرڈ نہیں ہے۔',
    pwdFormatToast: 'پاس ورڈ کا فارمیٹ غلط ہے۔',
    resetSuccessToast: 'کامیابی سے \n دوبارہ ترتیب دیں۔',
    pwdNotMatchToast: 'پاس ورڈ دو بار نہیں ملتے ہیں۔',
    emailFormatToast: 'غلط ای میل فارمیٹ',
    phoneNumberFormatToast: 'فون نمبر کا فارمیٹ غلط ہے۔',
    invalidAreaCodeToast: 'غلط ایریا کوڈ',
    login: 'لاگ ان کریں۔',
    pwdLogin: 'پاس ورڈ کے ذریعے لاگ ان کریں۔',
    emailCodeLogin: 'ای میل تصدیقی کوڈ کے ذریعے لاگ ان کریں۔',
    smsLogin: 'SMS کے ذریعے لاگ ان کریں۔',
    verifyEmail: 'ای میل کی تصدیق کریں۔',
    verifyPhone: 'فون کی تصدیق کریں۔',
    accountDangerDialog:
      'آپ کا اکاؤنٹ خطرے کے ساتھ پایا گیا ہے۔ براہ کرم اپنے اکاؤنٹ کی دوبارہ تصدیق کریں، بصورت دیگر آپ کا اکاؤنٹ استعمال کیے جانے کے قابل نہیں رہے گا۔',
    sendEmailCodeDialog: 'ہم نے آپ کے {0} ای میل پر ایک تصدیقی کوڈ بھیجا ہے۔ براہ کرم تصدیقی کوڈ درج کریں۔',
    sendSmsCodeDialog: 'ہم نے آپ کے {0} فون پر ایک توثیقی کوڈ بھیجا ہے۔ براہ کرم تصدیقی کوڈ درج کریں۔',
    graphicCodeEmptyToast: 'براہ کرم گرافک کوڈ درج کریں۔',
    countryUnselectToast: 'براہ کرم پہلے اپنا ملک منتخب کریں۔',
    unsupportedLoginTypeToast: 'غیر تعاون یافتہ لاگ ان کی قسم',
    pwdWrongLimitOverDialog:
      'غلط پاس ورڈ 3 بار درج کیا گیا ہے۔ لاگ ان کرنے کے لیے براہ کرم SMS تصدیقی کوڈ استعمال کریں۔',
    loginFailedToast: 'لاگ ان ناکام ہو گیا۔',
    signIn: 'سائن ان کریں۔',
    pwdPlaceholder: 'پاس ورڈ درج کریں۔',
    pwdNote: '8-16 حروف درج کریں (حروف اور اعداد شامل)',
    reenterPwdPlaceholder: 'پاس ورڈ دوبارہ درج کریں۔',
    reenterPwdNote: 'براہ کرم پاس ورڈ دوبارہ درج کریں۔',
    createAccount: 'اکاؤنٹ بنائیں',
    chooseCountryNote: 'براہ کرم ملک کا انتخاب کریں۔',
    pwdInconsistentToast: 'آپ کے درج کردہ پچھلے پاس ورڈ کے ساتھ ایک جیسا نہیں ہے۔',
    createSuccessToast: 'کامیابی سے \n تخلیق کریں۔',
    registerFailToast: 'رجسٹر ناکام ہو گیا۔',
    userNotExistToast: 'صارف موجود نہیں ہے۔',
    phoneIncorrectToast: 'براہ کرم اپنا فون چیک کریں۔',
    userExistToast: 'صارف پہلے سے موجود ہے۔',
    countryCodeRepeatToast: 'براہ کرم ملک کا کوڈ بار بار درج نہ کریں!',
    logoutDialog: 'کیا آپ کو لاگ آؤٹ کرنا یقینی ہے؟',
    pwdRequirement: 'پاس ورڈ میں حروف اور اعداد کے ساتھ کم از کم 8 سے 16 حروف کا ہونا ضروری ہے۔',
    signup: 'سائن اپ کریں۔',
    registerSuccessToast: 'رجسٹریشن \n کامیابی سے',
    oldPwdErrorToast: 'براہ کرم اپنا پرانا پاس ورڈ چیک کریں۔'
  },
  checkUserInfo: {
    title: 'مینجمنٹ سینٹر',
    emptyInfoNote:
      'یہاں موجودہ اکاؤنٹ کے لیے کوئی معلومات نہیں ہے، براہ کرم MetWallet اکاؤنٹ کو چیک کریں جس کی آپ کو تصدیق کرنے کی ضرورت ہے۔',
    infoNote: 'یہ رہی آپ کی تصدیقی معلومات۔',
    lastSuccessWithdrawal: 'آخری کامیاب واپسی',
    copyBtn: 'کاپی',
    successToast: 'کامیابی کے ساتھ کاپی ہو گیا!',
    failToast: 'کاپی کرنے میں ناکام!'
  },
  country: {
    title: 'علاقہ منتخب کریں۔',
    popular: 'مقبول'
  },
  documentDetails: {
    title: 'دستاویز کی تفصیلات',
    contract: 'معاہدہ',
    goToSign: 'اس پر دستخط کرنے جائیں۔',
    download: 'ڈاؤن لوڈ کریں۔',
    upload: 'اپ لوڈ کریں۔',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., صرف دستاویزات۔',
    contentEmptyToast: 'براہ کرم مواد درج کریں۔',
    placeOfBirth: 'جائے پیدائش',
    occupation: 'پیشہ',
    fileForm: '(فائل فارم)',
    proofOfAddress: 'انگریزی میں ایڈریس کا ثبوت',
    residenceDoc: 'رہائشی دستاویز',
    textForm: '(ٹیکسٹ فارم)',
    contractAgent: 'کنٹریکٹ ایجنٹ',
    contractPayslip: 'معاہدہ پے سلپ',
    uncompletedToast: 'براہ کرم جمع کرانے کے لیے اسے مکمل کریں۔',
    successToast: 'کامیابی سے جمع کروائیں۔',
    undefinedFileTypeToast: 'غیر متعینہ فائل اپ لوڈ کی قسم',
    uploadFailToast: 'اپ لوڈ ناکام ہو گیا۔'
  },
  filters: {
    amount: 'رقم',
    filter: 'فلٹرز',
    time: 'وقت',
    reset: 'دوبارہ ترتیب دیں۔',
    timePickerTitle: 'منتخب کریں {0} وقت',
    start: 'شروع کریں۔',
    end: 'ختم',
    maximum: 'زیادہ سے زیادہ',
    minimum: 'کم از کم'
  },
  home: {
    balance: 'توازن',
    transactions: 'لین دین',
    availableBalance: 'دستیاب بیلنس',
    noWithdrawalMethodToast: 'کم از کم واپسی کا ایک طریقہ درکار ہے۔',
    linkAccount: 'اکاؤنٹ لنک کریں۔',
    all: 'تمام',
    cashIn: 'کیش ان',
    loading: 'لوڈ ہو رہا ہے...',
    noMore: 'مزید لین دین نہیں۔',
    reload: 'لوڈنگ ناکام، دوبارہ لوڈ کرنے کے لیے کلک کریں۔',
    receivedFrom: 'سے موصول ہوا۔',
    transferredTo: 'کو منتقل کر دیا گیا۔',
    fee: 'میں منتقل کرنے کی فیس',
    myEmail: 'میرا ای میل',
    myPhone: 'میرا فون',
    invalidBasicLevelDialog:
      'آپ کے نام کے خانے میں علامتیں، خالی جگہیں، یا نمبر شامل ہونے کی وجہ سے، اکاؤنٹ سے نکلوانا ممکن نہیں ہے۔ براہ کرم بنیادی معلومات دوبارہ بھریں (یقینی بنائیں کہ نام میں علامتیں، خالی جگہیں، یا نمبر شامل نہیں ہیں اور اگر آپ کا کوئی خاندانی یا درمیانی نام نہیں ہے تو اسے خالی چھوڑ دیں۔)',
    lackLastNameDialog: 'آپ کا آخری نام نہیں بھرا گیا ہے، جو آپ کی واپسی میں رکاوٹ بنے گا۔',
    fillIn: 'بھریں۔',
    viewDetails: 'تفصیلات دیکھیں',
    docReviewingDialogTitle: 'براہ کرم دستاویز کے پاس ہونے کا انتظار کریں۔',
    docReviewingDialogContent:
      'آپ نے دستاویز جمع کرادی ہے، لیکن آپ اپنے دستاویز کے پاس ہونے سے پہلے MetWallet استعمال نہیں کرسکتے ہیں۔<br>سرکاری عملہ جلد ہی اس پر کارروائی کرے گا، براہ کرم تھوڑی دیر انتظار کریں۔',
    docPassedDialog:
      'آپ نے جو دستاویز جمع کرائی ہے وہ پاس ہو گئی ہے۔ <br>آپ اب عام طور پر MetWallet استعمال کر سکتے ہیں۔',
    docUnqualifiedDialog: 'آپ کی جمع کرائی گئی دستاویز نا اہل ہے۔ <br>براہ کرم ایک اہل جمع کروائیں۔',
    goToSubmit: 'جاؤ اسے جمع کرو',
    uncompletedDialog: 'MetWallet کو عام طور پر استعمال کرنے کے لیے آپ کو اسے مکمل کرنا چاہیے۔',
    useMetWalletNormallyAfterPassed: 'دستاویز پاس ہونے کے بعد آپ عام طور پر MetWallet استعمال کر سکتے ہیں۔',
    requireSemiVerifiedDialog:
      '{0}، بینک کی ضرورت کے لیے، آپ کو کامیاب انخلا کے لیے 48 گھنٹوں میں نیم تصدیق شدہ حصہ مکمل کرنا ہوگا۔',
    goToVerify: 'جا کر تصدیق کریں۔',
    emailInvalidDialog:
      '{0}، آپ کا ای میل پتہ وہی ہے جو دوسرے شخص کا ہے۔ پرائیویسی انشورنس کے لیے، براہ کرم جلد از جلد اپنا ای میل ایڈریس درج کریں۔',
    later: 'بعد میں',
    transferRequireSemiVerifiedDialog: 'براہ کرم منتقلی سے پہلے نیم تصدیق شدہ تصدیق مکمل کریں۔',
    modifyBtnText: 'میری معلومات میں ترمیم کریں',
    unmodifiedTitle: 'ترمیم کرنے سے قاصر',
    unmodifiedContent: 'آپ کا رقم نکالنے کا آرڈر زیر کار ہے۔ ابھی معلومات میں ترمیم نہیں کی جا سکتی۔'
  },
  signing: {
    signature: 'دستخط',
    date: 'تاریخ',
    employeeName: 'ملازم کا نام',
    designation: 'عہدہ',
    month: 'مہینہ',
    year: 'سال',
    earnings: 'کمائی',
    deductions: 'کٹوتیاں',
    basic: 'بنیادی اور ڈی اے (USD)',
    totalAddition: 'کل اضافہ',
    totalDeduction: 'کل کٹوتی',
    salary: 'NET تنخواہ',
    refNo: 'حوالہ نمبر',
    paymentTransferDate: 'ادائیگی کی منتقلی کی تاریخ',
    nameOfBank: 'بینک کا نام',
    signatureOfEmployee: 'ملازم کے دستخط',
    director: 'ڈائریکٹر',
    signNote: 'براہ کرم اپنے نام پر دستخط کریں۔',
    preview: 'پیش نظارہ',
    clear: 'صاف',
    save: 'محفوظ کریں۔',
    noSignatureToast: 'آپ بغیر دستخط کے محفوظ نہیں کر سکتے۔',
    fieldEmptyToast: 'براہ کرم تمام معلومات پُر کریں۔'
  },
  transactionDetail: {
    title: 'لین دین کی تفصیل',
    status: 'حیثیت',
    pending: 'زیر التواء',
    completed: 'مکمل',
    success: 'کامیابی',
    failed: 'ناکام',
    cancelled: 'منسوخ',
    onHold: 'ہولڈ پر',
    reason: 'حیثیت کی وجہ',
    description: 'تفصیل',
    creationDate: 'تخلیق کی تاریخ',
    lastStatusDate: 'آخری حیثیت کی تاریخ',
    requestedAmount: 'طلب کردہ رقم',
    receiveAmount: 'رقم وصول کریں۔',
    transferAmount: 'منتقلی کی رقم',
    amountToPay: 'ادا کرنے کی رقم',
    transferFee: 'ٹرانسفر فیس',
    processingFee: 'پروسیسنگ فیس',
    method: 'طریقہ',
    country: 'ملک',
    name: 'نام',
    bankPendingText: 'حتمی بینک جائزے کے تحت',
    pendingText: '{0} جائزے کے تحت',
    chametSalary: 'چمٹ تنخواہ',
    userSalary: 'صارف کی تنخواہ',
    comm: 'Comm',
    gemgalaSalary: 'Gemgala تنخواہ'
  },
  transfer: {
    title: 'میٹ والٹ اکاؤنٹ میں',
    noPayPwdDialog: 'منتقلی سے پہلے براہ کرم 6 ہندسوں کا ادائیگی کا پاس ورڈ سیٹ کریں۔',
    records: 'ریکارڈز',
    cashInOut: '{0} میں کیش، کیش آؤٹ {1}',
    transfer: 'منتقلی',
    fee: 'فیس',
    remark: 'تبصرہ',
    transferTo: '{0} پر منتقل کریں',
    remarkPlaceholder: 'ٹرانسفر ریمارکس شامل کریں (100 حروف سے کم)',
    firstNameNote: 'براہ کرم اس کا پہلا نام درج کریں۔',
    sendingAmount: 'بھیجنے کی رقم',
    receivingAmount: 'وصول کرنے والی رقم',
    transferNow: 'ابھی منتقل کریں۔',
    noBalanceToast: 'منتقلی کی رقم بیلنس کی رقم سے بڑی ہے۔',
    amountTooLittleToast: 'منتقلی کی رقم $10 سے کم نہیں ہو سکتی۔'
  },
  bankData: {
    beneficiaryName: 'فائدہ اٹھانے والے کا نام',
    beneficiaryNamePlaceholder: 'نام درج کریں۔',
    beneficiaryLastname: 'فائدہ اٹھانے والے کا آخری نام',
    beneficiaryLastnamePlaceholder: 'آخری نام درج کریں۔',
    bankCode: 'بینک کوڈ',
    bankCodePlaceholder: 'بینک کوڈ منتخب کریں۔',
    bankIFSCCode: 'بینک IFSC کوڈ',
    bankIFSCCodePlaceholder: 'بینک IFSC درج کریں۔',
    bankAccount: 'بینک اکاؤنٹ',
    bankAccountPlaceholder: 'بینک اکاؤنٹ درج کریں۔',
    email: 'ای میل',
    emailPlaceholder: 'ای میل درج کریں۔',
    phoneNumber: 'فون نمبر',
    phoneNumberPlaceholder: 'فون نمبر درج کریں۔',
    address: 'پتہ',
    addressPlaceholder: 'ایڈریس درج کریں۔',
    city: 'شہر',
    cityPlaceholder: 'شہر میں داخل ہوں۔',
    state: 'ریاست',
    statePlaceholder: 'ریاست درج کریں۔',
    postCode: 'پوسٹ کوڈ',
    postCodePlaceholder: 'پوسٹ کوڈ درج کریں۔',
    documentId: 'دستاویز کی شناخت',
    documentIdPlaceholder: 'دستاویز کی شناخت درج کریں۔',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'دستاویز کی قسم',
    documentTypePlaceholder: 'دستاویز کی قسم منتخب کریں۔',
    accountType: 'اکاؤنٹ کی قسم',
    accountTypePlaceholder: 'اکاؤنٹ کی قسم منتخب کریں۔',
    cpfcnpjPlaceholder: 'CPFCNPJ درج کریں۔',
    bankBranch: 'بینک برانچ',
    bankBranchPlaceholder: 'بینک برانچ میں داخل ہوں۔',
    ribOfBankAccount: 'بینک اکاؤنٹ کا RIB',
    bankName: 'بینک کا نام',
    bankNamePlaceholder: 'بینک کا نام درج کریں۔',
    bicCode: 'BIC کوڈ',
    bicCodePlaceholder: 'BIC کوڈ درج کریں۔',
    ibanPlaceholder: 'IBAN درج کریں۔',
    bankSwift: 'بینک سوئفٹ',
    bankSwiftPlaceholder: 'بینک سوئفٹ میں داخل ہوں۔',
    name: 'نام',
    documentCountry: 'دستاویز کا ملک',
    documentCountryPlaceholder: 'دستاویز کا ملک منتخب کریں۔',
    issueDate: 'دستاویز جاری کرنے کی تاریخ',
    issueDatePlaceholder: 'ایشو کی تاریخ منتخب کریں۔',
    expireDate: 'دستاویز کی میعاد ختم ہونے کی تاریخ',
    expireDatePlaceholder: 'میعاد ختم ہونے کی تاریخ منتخب کریں۔',
    bankBranchName: 'بینک برانچ کا نام',
    bankBranchNamePlaceholder: 'برانچ کا نام درج کریں۔',
    branchPlaceholder: 'برانچ میں داخل ہوں۔',
    gender: 'جنس',
    genderPlaceholder: 'صنف منتخب کریں۔',
    birthday: 'سالگرہ',
    birthdayPlaceholder: 'سالگرہ کا انتخاب کریں۔',
    phone: 'فون',
    bankAddress: 'بینک کا پتہ',
    bankAddressPlaceholder: 'بینک کا پتہ درج کریں۔',
    bankAccountName: 'بینک اکاؤنٹ کا نام',
    bankAccountNamePlaceholder: 'بینک اکاؤنٹ کا نام درج کریں۔',
    province: 'صوبہ',
    provincePlaceholder: 'صوبہ داخل کریں۔',
    postalCode: 'پوسٹل کوڈ',
    postalCodePlaceholder: 'پوسٹل کوڈ درج کریں۔',
    savingsAccount: 'بچت اکاؤنٹ',
    abaRoutingNumber: 'ABA روٹنگ نمبر',
    englandBankAccount: 'انگلینڈ بینک اکاؤنٹ',
    bankBranch2: 'بینک برانچ',
    bankBranch2Placeholder: 'صرف اس صورت میں جب بینک سینٹینڈر ہو۔',
    paternalName: 'پدرانہ نام',
    paternalNamePlaceholder: 'والد کا نام درج کریں۔',
    passportIdNumber: 'پاسپورٹ آئی ڈی نمبر',
    bankNamePlaceholder2: 'بینک کا نام منتخب کریں۔',
    areaCode: 'ایریا کوڈ',
    phoneNumberNoAreaCode: 'فون نمبر (کوئی ایریا کوڈ نہیں)',
    idType: 'ID کی قسم',
    idNo: 'شناختی نمبر',
    idIssueDate: 'ID جاری کرنے کی تاریخ',
    idExpireDate: 'ID کی میعاد ختم ہونے کی تاریخ',
    ibanStyleToast: "براہ کرم 'SA' سے شروع ہونے والا مواد درج کریں جس کی لمبائی 24 حروف ہو۔"
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'آپ صرف ڈائمنڈ سیلرز کو منتقل کر سکتے ہیں۔',
    search: 'تلاش کریں۔',
    history: 'منتقل شدہ صارفین',
    confirm_content: 'کیا آپ واقعی {0} کو {1} میں منتقل کرنا چاہتے ہیں',
    success_content: '{0} کو {1} میں منتقل کر دیا گیا ہے',
    purchase: 'خریداری',
    purchase_success: 'آپ نے کامیابی سے {0} خرید لیا ہے',
    insufficient_balance: 'ناکافی توازن',
    purchase_diamond: 'ہیرے خریدیں۔',
    transfer_limit_2: 'منتقلی کی رقم $10 اور $30,000 کے درمیان ہونی چاہیے۔',
    no_data: 'کوئی ڈیٹا نہیں۔',
    invalid_number: 'براہ کرم ایک درست نمبر درج کریں۔',
    under_limit: 'منتقلی کی رقم $10 سے کم نہیں ہونی چاہیے۔',
    over_limit: 'منتقلی کی رقم $30,000 سے کم ہونی چاہیے۔'
  },
  redesign: {
    emailPlaceholder: 'ای میل ایڈریس درج کریں۔',
    retrievePwd: 'پاس ورڈ بازیافت کریں۔',
    resetPwd: 'پاس ورڈ دوبارہ ترتیب دیں۔',
    newPwdPlaceholder: 'نیا پاس ورڈ درج کریں۔',
    reenterNewPwdPlaceholder: 'نیا پاس ورڈ دوبارہ درج کریں۔',
    reenterPayPwdPlaceholder: 'براہ کرم ادائیگی کا پاس ورڈ دوبارہ درج کریں۔',
    sendToPhone: 'تصدیقی کوڈ آپ کے فون پر بھیج دیا گیا ہے۔',
    sendToWhatsapp: 'تصدیقی کوڈ آپ کے واٹس ایپ پر بھیج دیا گیا ہے۔',
    sendToEmail: 'تصدیقی کوڈ آپ کے ای میل پر بھیج دیا گیا ہے۔',
    invalidCode: 'غلط کوڈ',
    userId: 'یوزر آئی ڈی',
    other: 'دیگر',
    transactionRecord: 'لین دین کا ریکارڈ',
    bankCardInfo: 'بینک کارڈ اکاؤنٹ',
    withdrawInfo: 'واپسی اکاؤنٹ',
    toFillIn: 'بھرنا ہے۔',
    walletInfo: 'والیٹ اکاؤنٹ کی معلومات',
    toComplete: 'مکمل کیا جائے۔',
    verifyGuide: 'رقم نکلوانے کی مزید اہلیت حاصل کرنے کے لیے والیٹ اکاؤنٹ کی معلومات کو مکمل کریں۔',
    verifyNote: '{0} کی روزانہ کی واپسی کی اہلیت حاصل کرنے کے لیے درج ذیل معلومات کو مکمل کریں',
    verifyCompletedNote: '{0} کی روزانہ کی واپسی کی اہلیت حاصل کرنے کے لیے معلومات مکمل کی جاتی ہے',
    continueBtnText: 'بھرنا جاری رکھیں',
    submitInfo: 'معلومات جمع کروائیں۔',
    transferAmount: 'منتقلی کی رقم',
    newEmailVerify: 'نئی ای میل کی تصدیق',
    verifyCodePlaceholder: 'تصدیقی کوڈ درج کریں۔',
    emailIncorrectToast: 'براہ کرم درست ای میل ایڈریس درج کریں۔',
    newPhone: 'نیا فون نمبر',
    accountAdded: 'اکاؤنٹ کی معلومات شامل کی گئی۔',
    accountToAdd: 'دوسرے اکاؤنٹس شامل کیے جاسکتے ہیں۔',
    edit: 'ترمیم کریں۔',
    enterPayPwd: 'ادائیگی کا پاس ورڈ درج کریں۔',
    deleteBtnText: 'حذف کریں۔',
    transferTo: 'میں منتقل کریں۔',
    withdrawable: 'قابل واپسی',
    goSet: 'سیٹ ہو جاؤ',
    goModify: 'جائیں ترمیم کریں۔'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/ur.js